import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function PlatformVersion({ version }) {
  const { t } = useTranslation();

  return (
    <Box sx={{ px: 2, pb: 1.25, bgcolor: '#fff', flexShrink: 0 }}>
      <Typography variant="caption" sx={{ color: '#626578', fontSize: '0.7rem', overflowWrap: 'anywhere' }}>
        {t('sidebar.platform_version', { version: version && version !== 'unknown' ? version : t('sidebar.version_unavailable') })}
      </Typography>
    </Box>
  );
}
